import { Component, computed, inject, input, output } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { KENDO_FORMFIELD } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { WorkflowMiniDto, WorkflowsClient } from '@unity/clients';
import { DropdownControlComponent } from '@unity/forms/dropdown-control/dropdown-control.component';

@Component({
  selector: 'unity-dropdown-workflow-control',
  standalone: true,
  imports: [KENDO_DROPDOWNS, KENDO_FORMFIELD, KENDO_LABEL, ReactiveFormsModule, DropdownControlComponent],
  templateUrl: './dropdown-workflow-control.component.html',
  styleUrl: './dropdown-workflow-control.component.scss',
})
export class DropdownWorkflowControlComponent {
  private readonly workflowsClient = inject(WorkflowsClient);

  private allWorkflowsResource = rxResource({
    stream: () => this.workflowsClient.getAllAsDetailed(undefined, undefined, undefined, 'IsSystemWorkflow=false'),
  });

  protected readonly $workflows = computed(() => {
    if (!this.allWorkflowsResource.hasValue()) {
      return [];
    }
    return this.allWorkflowsResource.value().data;
  });

  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  public readonly $defaultItem = input<{ name: string; id: unknown }>({ name: '', id: null }, { alias: 'defaultItem' });
  public readonly $showHint = input(true, { alias: 'showHint' });

  public selectionChangeEvent = output<WorkflowMiniDto>();

  protected onSelectionChange(event: unknown) {
    this.selectionChangeEvent.emit(event as WorkflowMiniDto);
  }
}
